window.msNews = angular.module("msNews", ["MobiStream"]);

require("./api/newsApi");
require("./controllers/news");
require("./controllers/feed");
require("./controllers/article");

window.msNews.config(require("./routes.js"));

window.msNews.config([
  "ngRequireProvider",
  function(ngRequire) {
    // ngRequire.addTemplates({
    //     'src/apps/news/views/desktop/home-feed.html': require('./views/desktop/home-feed.html'),
    // })
  }
]);

window.msNews.run([
  function() {
    require("./scss/index.scss");
  }
]);



// WEBPACK FOOTER //
// ./src/apps/news/index.js